import styled from 'styled-components';
import ChaMeta12 from 'dc/ChaMeta12';

export const Wrapper = styled.div`
  background-color: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

export const ListWrapper = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 294px;
  overflow-y: auto;
`;

export const ActivitiesItem = styled(ChaMeta12)`
  margin-bottom: 10px;
  & i:first-child {
    color: #0099a9;
  }
  div div span {
    text-overflow: clip;
    white-space: normal;
    max-width: 230px;
  }
`;
